export default function Calculate(props) {
  const calculateRemainingAmount = () => {
    const paymentNet = parseFloat(props.PaymentDetail?.paymentNet || 0);
    const paymentTotal = parseFloat(props.PaymentDetail?.paymentTotal || 0);
    return Math.max(0, paymentNet - paymentTotal).toFixed(2);
  };

  const remainingAmount = calculateRemainingAmount();

  const Num = (n) => {
    // ดึงค่าปัจจุบันมาใช้
    let m = props.moneypay;

    // ถ้าค่าปัจจุบันเป็น "0" (ไม่มีจุดทศนิยม) และกดเลข 0 ซ้ำ ให้ค่ายังคงเป็น "0"
    if (n === "0" && (m === "" || m === "0")) {
      props.setMoneypay("0");
      return;
    }

    // กรณีพิเศษเมื่อกดจุดทศนิยม
    if (n === ".") {
      // ถ้ามีจุดทศนิยมอยู่แล้ว ไม่ต้องทำอะไร
      if (m.includes(".")) {
        return;
      }

      // ถ้า m ว่าง หรือเป็น 0 ให้เริ่มด้วย "0."
      if (m === "" || m === "0") {
        props.setMoneypay("0.");
        return;
      }

      // เพิ่มจุดทศนิยม
      props.setMoneypay(m + ".");
      return;
    }

    // ถ้าค่าปัจจุบันเป็น "0" (ไม่มีจุดทศนิยม) และกดตัวเลขอื่นที่ไม่ใช่ "0" ให้แทนที่ด้วยค่าใหม่
    if (m === "0" && n !== "0" && n !== ".") {
      props.setMoneypay(n);
      return;
    }

    // ตรวจสอบว่ามีจุดทศนิยมหรือไม่
    const hasDecimal = m.includes(".");

    // แยกส่วนจำนวนเต็มและส่วนทศนิยม
    const parts = m.split(".");
    const wholeNumberPart = parts[0];

    // ถ้าเพิ่มเลขที่ส่วนจำนวนเต็ม และยังไม่มีจุดทศนิยม
    if (!hasDecimal && wholeNumberPart.length >= 9) {
      return; // จำกัดความยาวส่วนจำนวนเต็มไม่เกิน 9 หลัก
    }

    // ถ้ามีจุดทศนิยมแล้ว ให้เพิ่มตัวเลขต่อได้เลย (รวมถึงเลข 0)
    if (hasDecimal) {
      props.setMoneypay(m + n);
      return;
    }

    // เพิ่มตัวเลขตามปกติในทุกกรณี
    props.setMoneypay(m + n);
  };

  // ฟังก์ชั่นสำหรับปุ่มตัวเลขที่กำหนดไว้ล่วงหน้า (20, 50, ฯลฯ)
  const handlePresetAmount = (amount) => {
    // ตรวจสอบให้แน่ใจว่าค่าที่ส่งไปอยู่ในรูปแบบที่ถูกต้อง
    const currentAmount = Number(props.moneypay) + Number(amount);

    const formattedAmount = parseFloat(currentAmount).toString();

    props.setMoneypay(formattedAmount);
  };

  const handleBackspace = () => {
    // ถ้าค่าเป็น "0.00" หรือว่าง ไม่ต้องทำอะไร
    if (props.moneypay === "0.00" || props.moneypay === "" || props.moneypay === "0") {
      props.setMoneypay("0");
      return;
    }

    // ถ้ามีแค่ 1 ตัว กลับไปเป็น "0"
    if (props.moneypay.length === 1) {
      props.setMoneypay("0");
      return;
    }

    // ลบตัวอักษรสุดท้าย
    const newValue = props.moneypay.slice(0, -1);

    // ถ้าลบแล้วเหลือแค่จุดทศนิยม (เช่น "2.") เติม "0" ต่อท้ายเพื่อให้เป็น valid number
    if (newValue.endsWith(".")) {
      props.setMoneypay(newValue + "0");
      return;
    }

    props.setMoneypay(newValue.length > 0 ? newValue : "0");
  };

  // สไตล์สำหรับป้องกันการเลือกข้อความ
  const noSelectStyle = {
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
    userSelect: "none",
  };

  return (
    <div className="mt-2 d-flex">
      <div className="">
        <div className="d-flex">
          <div>
            <div
              id="clear"
              className="clear btn-cal-5"
              onClick={() => {
                props.setMoneypay("0");
              }}
              style={noSelectStyle}
            >
              CE
            </div>
          </div>
          <div id="del" className="del btn-cal-4 d-flex justify-content-center" onClick={handleBackspace} style={noSelectStyle}>
            <img src="../img/14T090753.464.png" width="29" height="20" className="align-self-center" alt="delete" />
          </div>
        </div>
        <div className="d-flex">
          <div className="btn-cal-1" onClick={() => Num("7")} style={noSelectStyle}>
            7
          </div>
          <div className="btn-cal-1" onClick={() => Num("8")} style={noSelectStyle}>
            8
          </div>
          <div className="btn-cal-1" onClick={() => Num("9")} style={noSelectStyle}>
            9
          </div>
        </div>
        <div className="d-flex">
          <div>
            <div className="d-flex">
              <div className="btn-cal-1" onClick={() => Num("4")} style={noSelectStyle}>
                4
              </div>
              <div className="btn-cal-1" onClick={() => Num("5")} style={noSelectStyle}>
                5
              </div>
              <div className="btn-cal-1" onClick={() => Num("6")} style={noSelectStyle}>
                6
              </div>
            </div>
            <div className="d-flex">
              <div className="btn-cal-1" onClick={() => Num("1")} style={noSelectStyle}>
                1
              </div>
              <div className="btn-cal-1" onClick={() => Num("2")} style={noSelectStyle}>
                2
              </div>
              <div className="btn-cal-1" onClick={() => Num("3")} style={noSelectStyle}>
                3
              </div>
            </div>
            <div className="d-flex">
              <div className="btn-cal-6" onClick={() => Num("0")} style={noSelectStyle}>
                0
              </div>
              <div className="btn-cal-1" onClick={() => Num(".")} style={noSelectStyle}>
                .
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" ">
        <div>
          <div
            className="btn-cal-7 tmp_price"
            onClick={() => {
              // แปลงค่าให้อยู่ในรูปแบบที่ถูกต้องก่อนส่งไปยัง state
              const amount = parseFloat(remainingAmount).toString();
              props.setMoneypay(amount);
            }}
            style={noSelectStyle}
          >
            {remainingAmount}
          </div>
        </div>
        <button className="tmp_price btn-tran" onClick={() => handlePresetAmount("20.00")} style={noSelectStyle}>
          20
        </button>
        <button className="tmp_price btn-tran" onClick={() => handlePresetAmount("50.00")} style={noSelectStyle}>
          50
        </button>
        <button className="tmp_price btn-tran" onClick={() => handlePresetAmount("100.00")} style={noSelectStyle}>
          100
        </button>
        <button className="tmp_price btn-tran" onClick={() => handlePresetAmount("500.00")} style={noSelectStyle}>
          500
        </button>
        <button className="tmp_price btn-tran" onClick={() => handlePresetAmount("1000.00")} style={noSelectStyle}>
          1000
        </button>
      </div>
    </div>
  );
}
